// FeaturesSection.jsx
import { motion } from "framer-motion";
import { FaCogs, FaHandHoldingUsd, FaPlay, FaRocket, FaShieldAlt } from "react-icons/fa";
import "../css/FeaturesSection.css";

const features = [
  {
    id: 1,
    icon: <FaRocket />,
    title: "Instant Credit Disbursal",
    desc: "Experience rapid processing and direct loan disbursal to meet urgent needs.",
  },
  {
    id: 2,
    icon: <FaHandHoldingUsd />,
    title: "Flexible Loan Options",
    desc: "Tailored lending schemes with customized EMI schedules and tenure options.",
  },
  {
    id: 3,
    icon: <FaShieldAlt />,
    title: "Transparent Terms",
    desc: "No hidden charges or surprise fees—enjoy complete clarity from application to closure.",
  },
  {
    id: 4,
    icon: <FaCogs />,
    title: "Paperless Digital Process",
    desc: "Hassle-free online documentation and automated eligibility assessment.",
  },
];

const FeaturesSection = () => {
  return (
    <section className="landing-techvision-feature-section">
      <div className="landing-techvision-feature-section-animated-bg"></div>

      <motion.div
        className="landing-techvision-feature-section-left"
        initial={{ opacity: 0, x: -60 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <div className="landing-techvision-feature-section-grid">
          {features.map((item) => (
            <motion.div
              key={item.id}
              className="landing-techvision-feature-section-card landing-techvision-feature-section-glass-card"
              whileHover={{ scale: 1.05, y: -5 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <div className="landing-techvision-feature-section-icon">{item.icon}</div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>

      <motion.div
        className="landing-techvision-feature-section-right"
        initial={{ opacity: 0, x: 60 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
      >
        <h2>
          Choose us for your{" "}
          <span className="landing-techvision-feature-section-highlight">borrowing needs</span>
        </h2>
        <p>
          Our commitment is to provide you with fast, transparent, and reliable credit solutions 
          that empower your personal, business, and community growth.
        </p>
        <motion.button
          className="landing-techvision-feature-section-demo-btn"
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <FaPlay className="landing-techvision-feature-section-play-icon" /> Watch Demo Video
        </motion.button>
      </motion.div>
    </section>
  );
};

export default FeaturesSection;